export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server) return

  const { routeGuard } = Auth.use()
  routeGuard(to.path)
})
